import { Component } from '@angular/core';
import { OptService } from 'src/app/services/opt.service';
declare const window: any;
@Component({
  selector: 'upsc-optout',
  templateUrl: './optout.component.html',
  styleUrls: ['./optout.component.scss']
})
export class OptoutComponent {


  constructor(private optService: OptService) { }
  user: any = {
    cpi: 1,
    LastName: '',
    StreetAddress1: '',
    StreetAddress2: '',
    StreetAddress3: '',
    FirstName: '',
    City: '',
    Country: '',
    State: '',
    Zip: '',
    EmailAddress: '',
    DoNotSell: '',
    DoNotShare: '',
    Keep_Remove: ''
  };

  onSubmit() {
    if (this.user.cpi == 1) {
      let FirstName = this.user.FirstName;
      let LastName = this.user.LastName;
      let StreetAddress1 = this.user.StreetAddress1;
      let City = this.user.City;
      let State = this.user.State;
      let Country = this.user.Country;
      let DoNotSell = this.user.DoNotSell;
      let DoNotShare = this.user.DoNotShare;
      let Zip = this.user.Zip;
      let EmailAddress = this.user.EmailAddress;
      let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailRegex.test(EmailAddress) && FirstName && LastName && Country && Zip && StreetAddress1 && City && State) {
        console.log(this.user);

        this.user.DoNotSell = DoNotSell ? "1" : "";
        this.user.DoNotShare = DoNotShare ? "2" : "";
        this.optService.submitLead(this.user).subscribe(
          response => {
            console.log('Lead submitted:', response);
            if (response.data.responseMessage) {
              alert('Your request to opt out of the sales, sharing, and target advertising was received.');
              this.user = {
                cpi: 1,
                LastName: '',
                StreetAddress1: '',
                StreetAddress2: '',
                StreetAddress3: '',
                FirstName: '',
                City: '',
                Country: '',
                State: '',
                Zip: '',
                EmailAddress: '',
                DoNotSell: '',
                DoNotShare: '',
                Keep_Remove: ''
              };
            }
            else {
              alert("Something went wrong. Please try again");
            }


          },
          error => {
            // console.error('Error:', error);
            alert('Failed to submit lead.');
          }
        );
      }
      else if (!emailRegex.test(EmailAddress) && FirstName && LastName && Country && Zip && StreetAddress1 && City && State) {
        alert('Please fill valid email ID');
      }
      else {
        alert('Please fill in all fields!');
        return false;
      }

    }
  }
  openConsentPreferences(event: Event): void {
    event.preventDefault();
 
    if (typeof window !== 'undefined' && window.OneTrust?.ToggleInfoDisplay) {
      window.OneTrust.ToggleInfoDisplay();
      window.scrollTo(0, 0);
    } else {
      console.warn('OneTrust library is not available.');
    }
  }
}
